export default __webpack_public_path__ + "static/s2-e4f9dcbd249c9a339f736bc9dbae2517.png";